// extracted by mini-css-extract-plugin
module.exports = {"container":"AppTitle_container__qL2Vx","title":"AppTitle_title__Ywppd","flag":"AppTitle_flag__1vHm4"};